import { useContext } from 'react';
import { Alert, Grid, Paper } from '@mui/material';
import { UnitsContext } from '../../../../Contexts/UnitsContext';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import PageHeading from '../../../../Components/PageHeading';
import useCommonStyles from '../../../../commonStyles';

const PageLevelContentVideosConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	const { siteRawConfig } = useContext(UnitsContext);
	const isSiteEnabled = siteRawConfig?.pageLevelContentVideos?.enabled === true;

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Page Level Content Override"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'Page Level Content Override']}
				description="Disable page level content videos for the selected section."
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			{!isSiteEnabled && (
				<Alert severity="info" sx={{ mx: 6, mt: 2 }}>
					Page Level Content Videos is disabled for this site. Enable it on the Page Level Content page
					to display videos in sections that are not disabled.
				</Alert>
			)}
			<Grid container spacing={0} style={{ margin: '4rem 0 0 5rem', width: '90%' }}>
				<Grid item xs={4}>
					<CheckBoxInput
						keyData={keyData}
						label="Disable for this section"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default PageLevelContentVideosConfig;
